(function () {
  // ─── Suchergebnisseite ───────────────────────────────────────────────────

  function getQuery() {
    return (new URLSearchParams(window.location.search).get('q') ?? '').toLowerCase().trim();
  }

  function renderResultsPage(brands) {
    const container = document.getElementById('brand-search-results');
    const list = container?.querySelector('.brand-search-results__list');
    const template = document.getElementById('brand-card-template');
    if (!container || !list || !template) return;

    list.innerHTML = '';

    if (brands.length === 0) {
      container.style.display = 'none';
      return;
    }

    brands.forEach((brand) => {
      const clone = template.content.cloneNode(true);
      const link = clone.querySelector('.brand-search-results__link');
      const img = clone.querySelector('.brand-search-results__img');
      const nameEl = clone.querySelector('.brand-search-results__name');

      link.href = brand.url;
      nameEl.textContent = brand.name;

      if (brand.image) {
        img.src = brand.image;
        img.alt = brand.name;
      } else {
        img.closest('.card__media')?.remove();
      }

      list.appendChild(clone);
    });

    container.style.display = '';
    document.getElementById('search-no-results')?.style.setProperty('display', 'none');
  }

  function runResultsPage() {
    const q = getQuery();
    if (q.length < 2) return;
    const matches = (window.mingbudBrands ?? []).filter((b) =>
      b.name.toLowerCase().includes(q)
    );
    renderResultsPage(matches);
    injectBrandProductsOnResultsPage(matches);
  }

  // ─── Predictive Search Dropdown ──────────────────────────────────────────

  function injectBrandsIntoDropdown(query) {
    if (query.length < 2) return;

    const matches = (window.mingbudBrands ?? [])
      .filter((b) => b.name.toLowerCase().includes(query.toLowerCase()))
      .slice(0, 3);

    document.querySelector('.brand-predictive-results')?.remove();

    if (matches.length === 0) return;

    const resultsContainer = document.querySelector('#predictive-search-results');
    if (!resultsContainer) return;

    const section = document.createElement('div');
    section.className = 'brand-predictive-results predictive-search__result-group';

    const heading = document.createElement('h2');
    heading.className = 'predictive-search__heading text-body caption-with-letter-spacing';
    heading.textContent = 'Brands';
    section.appendChild(heading);

    const ul = document.createElement('ul');
    ul.className = 'predictive-search__results-list list-unstyled';
    ul.setAttribute('role', 'group');

    matches.forEach((brand) => {
      const li = document.createElement('li');
      li.className = 'predictive-search__list-item';
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');

      const a = document.createElement('a');
      a.href = brand.url;
      a.tabIndex = -1;
      a.className = brand.image
        ? 'predictive-search__item predictive-search__item--link-with-thumbnail link link--text'
        : 'predictive-search__item link link--text';

      if (brand.image) {
        const img = document.createElement('img');
        img.className = 'predictive-search__image';
        img.src = brand.image;
        img.alt = brand.name;
        img.width = 50;
        img.height = 50;
        img.style.objectFit = 'cover';
        a.appendChild(img);
      }

      const content = document.createElement('div');
      content.className = 'predictive-search__item-content predictive-search__item-content--centered';
      const p = document.createElement('p');
      p.className = 'predictive-search__item-heading h5';
      p.textContent = brand.name;
      content.appendChild(p);
      a.appendChild(content);
      li.appendChild(a);
      ul.appendChild(li);
    });

    section.appendChild(ul);
    const searchForBtn = resultsContainer.querySelector('#predictive-search-option-search-keywords');
    resultsContainer.insertBefore(section, searchForBtn ?? null);
  }

  function setupPredictiveObserver() {
    if (typeof PredictiveSearch === 'undefined') return;
    const original = PredictiveSearch.prototype.renderSearchResults;
    PredictiveSearch.prototype.renderSearchResults = function (markup) {
      original.call(this, markup);
      const q = this.getQuery();
      const matches = (window.mingbudBrands ?? []).filter((b) =>
        b.name.toLowerCase().includes(q.toLowerCase())
      );
      injectBrandsIntoDropdown(q);
      injectBrandProductsInDropdown(matches, q, this);
    };
  }

  // ─── Produkte einer Brand laden ──────────────────────────────────────────

  const productCache = {};

  async function fetchBrandProducts(brandId) {
    if (productCache[brandId]) return productCache[brandId];
    const gid = encodeURIComponent(`gid://shopify/Metaobject/${brandId}`);
    const url = `/collections/all?filter.p.m.custom.brand=${gid}&section_id=main-collection-product-grid`;
    try {
      const response = await fetch(url);
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const items = Array.from(doc.querySelectorAll('.grid__item'));
      productCache[brandId] = items;
      return items;
    } catch {
      return [];
    }
  }

  async function injectBrandProductsOnResultsPage(brands) {
    const container = document.getElementById('brand-search-results');
    if (!container) return;

    let productSection = container.querySelector('.brand-search-products');
    if (!productSection) {
      productSection = document.createElement('div');
      productSection.className = 'brand-search-products';
      container.appendChild(productSection);
    }
    productSection.innerHTML = '';

    for (const brand of brands) {
      if (!brand.id) continue;
      const items = await fetchBrandProducts(brand.id);
      if (!items.length) continue;

      const heading = document.createElement('h2');
      heading.className = 'brand-search-results__heading';
      heading.textContent = `Produkte von ${brand.name}`;
      productSection.appendChild(heading);

      const grid = document.createElement('ul');
      grid.className = 'grid product-grid grid--2-col-tablet-down grid--4-col-desktop';
      grid.setAttribute('role', 'list');
      items.forEach((item) => {
        item.classList.add('grid__item');
        item.querySelectorAll('[style*="--ratio-percent"]').forEach((el) => {
          el.style.setProperty('--ratio-percent', '100%');
        });
        grid.appendChild(item);
      });
      productSection.appendChild(grid);
    }
  }

  async function injectBrandProductsInDropdown(brands, query, instance) {
    for (const brand of brands) {
      if (!brand.id) continue;
      const items = await fetchBrandProducts(brand.id);
      if (!items.length) continue;

      // Nach dem Fetch prüfen ob die Suche noch aktuell ist
      if (instance.getQuery().toLowerCase() !== query.toLowerCase()) return;

      const resultsContainer = document.querySelector('#predictive-search-results');
      if (!resultsContainer) return;

      resultsContainer.querySelector('.brand-predictive-products')?.remove();

      const section = document.createElement('div');
      section.className = 'brand-predictive-products predictive-search__result-group';

      const heading = document.createElement('h2');
      heading.className = 'predictive-search__heading text-body caption-with-letter-spacing';
      heading.textContent = `Produkte von ${brand.name}`;
      section.appendChild(heading);

      const ul = document.createElement('ul');
      ul.className = 'predictive-search__results-list list-unstyled';
      ul.setAttribute('role', 'group');

      items.forEach((item) => {
        const productLink = item.querySelector('a[href*="/products/"]');
        const img = item.querySelector('img');
        const title = item.querySelector('.card__heading a, .card__heading');
        if (!productLink) return;

        const li = document.createElement('li');
        li.className = 'predictive-search__list-item';
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');

        const a = document.createElement('a');
        a.href = productLink.getAttribute('href');
        a.tabIndex = -1;
        a.className = 'predictive-search__item predictive-search__item--link-with-thumbnail link link--text';

        if (img) {
          const thumbnail = document.createElement('img');
          thumbnail.className = 'predictive-search__image';
          thumbnail.src = img.src;
          thumbnail.alt = img.alt;
          thumbnail.width = 50;
          thumbnail.height = 50;
          thumbnail.style.objectFit = 'cover';
          a.appendChild(thumbnail);
        }

        const content = document.createElement('div');
        content.className = 'predictive-search__item-content predictive-search__item-content--centered';
        const p = document.createElement('p');
        p.className = 'predictive-search__item-heading h5';
        p.textContent = title?.textContent?.trim() ?? '';
        content.appendChild(p);
        a.appendChild(content);
        li.appendChild(a);
        ul.appendChild(li);
      });

      section.appendChild(ul);
      const searchForBtn = resultsContainer.querySelector('#predictive-search-option-search-keywords');
      resultsContainer.insertBefore(section, searchForBtn ?? null);
      instance.resultsMaxHeight = false;
      instance.open();
      break;
    }
  }

  // ─── Init ────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runResultsPage);
  } else {
    runResultsPage();
  }

  // PredictiveSearch wird erst im Body geladen – auf load warten
  window.addEventListener('load', setupPredictiveObserver);
})();
